import { ValueOf } from '@doda/common/src/utils/typeUtil';

export const PAGES = {
  CAREER_RECOMMEND_JOB_LIST: 'CareerRecommendJobList',
  TOP: 'Top',
  INTENTION_JOB_LIST: 'IntentionJobList',
  JOB_SEARCH_DETAIL: 'JobSearchDetail',
  JOB_SEARCH_LIST: 'JobSearchList',
  JOB_HISTORY_LIST: 'JobHistoryList',
  MATCH_JOB_LIST: 'MatchJobList',
  FEATURED_JOB_LIST: 'FeaturedJobList',
  CONDITION_CHANGE: 'ConditionChange',
  RECOMMEND_JOB_LIST: 'RecommendJobList',
  REFERRED_JOB_DETAIL: 'ReferredJobDetail',
  SELECT_JOB_LIST: 'SelectJobList',
  STATION_LIST: 'StationList',
  ROUTE_LIST: 'RouteList',
  QUALIFICATION_LIST: 'QualificationList',
  NEW_JOB_LIST: 'NewJobList',
  JOB_SEARCH_TOP: 'JobSearchTop',
  EVENT_DETAIL_DISPLAY: 'EventDetailDisplay',
  NONE: 'none',
  JOB_TREND: 'JobTrend',
  JOB_RANKING: 'JobRanking',
  OCCUPATION: 'Occupation',
} as const;

export type PageType = ValueOf<typeof PAGES>;

/**
 * ページID
 * @param MEMBER_REGIST 会員登録画面
 * @param PROFILE_REGIST プロフィール登録画面
 * @param EDUCATION_REGIST 学歴登録画面
 * @param PERSONAL_WORK_EXPERIENCE_REGIST 職歴登録画面
 * @param SELF_PR_REGIST 自己PR登録画面
 * @param JOB_SUMMARY_REGIST 職務要約登録画面
 */
export const PAGE_ID = {
  MEMBER_REGIST: 'F101001',
  PROFILE_REGIST: 'F116015',
  EDUCATION_REGIST: 'F116016',
  PERSONAL_WORK_EXPERIENCE_REGIST: 'F116003',
  SELF_PR_REGIST: 'F116018',
  JOB_SUMMARY_REGIST: 'F116021',
} as const;
